module.exports = __webpack_public_path__ + "static/media/210427_1차완성_Ash.10f24d23.jpg";